import React, { useState } from 'react'
import { Card, CardBody, CardFooter, Row, Col } from "reactstrap"
import CurrencyFormat from 'react-currency-format'
import ProductCardDescription from "../ProductCard/ProductCardDescription"
import ProductCardGallery from "../ProductCard/ProductCardGallery"
import ProductCardOptions from '../ProductCard/ProductCardOptions'

const ProductCard = ({
    photos,
    price,
    retailPrice,
    profit,
    code,
    productName,
    supplierName,
    description,
    variants,
    firstVariantValue,
    secondVariantValue,
    thirdVariantValue,
    onChangeFirstVariant,
    onChangeSecondVariant,
    onChangeThirdVariant,
    quantity,
    onChangeQuantity,
    shareButtonText,
    shareButtonAction,
    addToCartButtonText,
    addToCartButtonAction,
    addToCartButtonDisabled,
    itemAction,
    showFooterOptions,
    showVariants,
    showAddProductButton,
    actionAddProductButton,
    textAddProductButton,
    styleAddProductButton,
    disabled,
    showSelectMultiple,
    actionAddProductMultiple,
    textAddProductMultipleButton,
    textRemoveProductMultipleButton,
    stock,
}) => {
    const [itemChecked, setItemChecked] = useState(false)

    return (
        <Card className="product-detail-container">
            <CardBody>
                <ProductCardGallery
                    photos={photos}
                    imageClick={itemAction}
                />

                <ProductCardDescription
                    itemAction={itemAction}
                    code={code}
                    productName={productName}
                    supplierName={supplierName}
                    description={description}
                />

                {showVariants && (
                    <ProductCardOptions
                        disabled={disabled}
                        variants={variants}
                        firstVariantValue={firstVariantValue}
                        secondVariantValue={secondVariantValue}
                        thirdVariantValue={thirdVariantValue}
                        onChangeFirstVariant={onChangeFirstVariant}
                        onChangeSecondVariant={onChangeSecondVariant}
                        onChangeThirdVariant={onChangeThirdVariant}
                        quantity={quantity}
                        onChangeQuantity={onChangeQuantity}
                        stock={stock}
                    />
                )}

                <Row>
                    {price > 0 && (
                        <Col sm={retailPrice > 0 ? 4 : 12}>
                            <div className="product-card-label">Precio Vendora</div>
                            <div className="product-price-tag">
                                <CurrencyFormat
                                    value={Math.round(price)}
                                    displayType="text"
                                    thousandSeparator
                                    prefix="$"
                                />
                            </div>
                            {
                                disabled && (
                                    <div style={{ textAlign: 'center' }}>
                                        NO DISPONIBLE
                                    </div>
                                )
                            }
                        </Col>
                    )}

                    {retailPrice > 0 && (
                        <Col sm={4}>
                            <div className="product-card-label">Precio Sugerido</div>
                            <div className="product-price-tag">
                                <CurrencyFormat
                                    value={Math.round(retailPrice)}
                                    displayType="text"
                                    thousandSeparator
                                    prefix="$"
                                />
                            </div>
                        </Col>
                    )}

                    {profit > 0 && (
                        <Col sm={4}>
                            <div className="product-card-label">Tu Ganancia</div>
                            <div className="product-price-tag">
                                <CurrencyFormat
                                    value={Math.round(profit)}
                                    displayType="text"
                                    thousandSeparator
                                    prefix="$"
                                />
                            </div>
                        </Col>
                    )}
                </Row>
            </CardBody>
            {
                showFooterOptions && (
                    <CardFooter className="bg-transparent border-top">
                        <div style={{ display: 'flex', textAlign: 'center' }}>
                            {addToCartButtonText && (
                                <button
                                    style={{ width: '95%', cursor: 'pointer', border: '1px solid grey', marginRight: '5px' }}
                                    disabled={addToCartButtonDisabled}
                                    onClick={addToCartButtonAction}
                                    className={`btn btn-default waves-effect waves-light`}
                                >
                                    <i className="bx bx-cart"></i> {addToCartButtonText}
                                </button>
                            )}
                            {shareButtonText && (
                                <button
                                    style={{ width: '95%', cursor: 'pointer' }}
                                    onClick={shareButtonAction}
                                    className={`btn btn-whatsapp waves-effect waves-light`}
                                >
                                    <i className="bx bxl-whatsapp"></i> {shareButtonText}
                                </button>
                            )}
                        </div>
                    </CardFooter>
                )
            }
            {
                showAddProductButton && (
                    <CardFooter className="bg-transparent border-top">
                        <Row className="font-size-20">
                            <Col sm="12">
                                <button
                                    style={{ width: '100%', cursor: disabled ? 'default' : 'pointer' }}
                                    onClick={actionAddProductButton}
                                    disabled={disabled}
                                    className={`btn ${styleAddProductButton} waves-effect waves-light`}
                                >
                                    {textAddProductButton}
                                </button>
                            </Col>
                        </Row>
                    </CardFooter>
                )
            }
            {
                showSelectMultiple && (
                    <CardFooter className="bg-transparent border-top">
                        <Row className="font-size-20">
                            <Col sm="12">
                                <button
                                    style={{ width: '100%', cursor: disabled ? 'default' : 'pointer' }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setItemChecked(!itemChecked)
                                        actionAddProductMultiple(!itemChecked)
                                    }}
                                    disabled={disabled}
                                    className={`btn ${itemChecked ? 'btn-danger' : 'btn-success'} waves-effect waves-light`}
                                >
                                    {!itemChecked && (
                                        <span>
                                            {textAddProductMultipleButton} <i className={`mdi mdi-check`}></i>
                                        </span>
                                    )}
                                    {itemChecked && (
                                        <span>
                                            {textRemoveProductMultipleButton} <i className={`mdi mdi-delete`}></i>
                                        </span>
                                    )}
                                </button>
                            </Col>
                        </Row>
                    </CardFooter>
                )
            }
        </Card>
    )
}

ProductCard.defaultProps = {
    disabled: false,
    styleAddProductButton: 'btn-success'
}

export default ProductCard
